var _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 425,
    height: 485,
    viewBox: "0 0 425 485",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M417.715 433.714L403.951 448.747M278.81 483.106H372.49L403.951 448.747M403.951 448.747L372.49 416.535L329.419 448.747H241.123M417.715 376.807H329.419L299.269 403.65H191.591L164.671 433.714M424.176 329.562H387.565L370.138 313.456M72.0677 340.3H173.285L224.971 288.76H343.417L370.138 313.456M417.715 260.843H387.565L372.49 238.295H343.417L315.421 267.286H224.971L181.9 222.803M164.671 205.009L181.9 222.803M181.9 222.803L152.827 252.254M403.951 189.977H350.955L315.421 226.484H278.81M420.946 202.862L374.644 155.618L265.889 154.544L241.123 128.774L198.051 85.8249L1 84.7511M370.138 313.456L343.417 340.3H251.891M315.421 150.249L255.121 90.1198V63.2765M255.121 19.2534V63.2765M255.121 63.2765L191.591 0.999969H77.4517M350.955 150.249V114.816",
    stroke: "url(#paint0_linear_41_900)",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_41_900",
    x1: 424.176,
    y1: 337.078,
    x2: 1,
    y2: 337.078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A4290",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A4290",
    stopOpacity: 0.04
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.cf3987e503b2ed9cf42220395009e1f7.svg";
export { ForwardRef as ReactComponent };